export default "__VITE_ASSET__52b8879a__"